import { DialogCloseEvent, DialogComponent } from '@theme/dialog';

class KbbcPromotionPopup extends DialogComponent {
  #timer;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener(DialogCloseEvent.eventName, this.#rememberDismissal);
    this.querySelector('[data-promotion-link]')?.addEventListener('click', this.#rememberDismissal);

    if (!this.#shouldOpen()) return;

    const delay = this.dataset.designMode === 'true' ? 0 : Number(this.dataset.delay || 1500);
    this.#timer = window.setTimeout(() => this.showDialog(), Math.max(0, delay));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.clearTimeout(this.#timer);
    this.removeEventListener(DialogCloseEvent.eventName, this.#rememberDismissal);
    this.querySelector('[data-promotion-link]')?.removeEventListener('click', this.#rememberDismissal);
  }

  #shouldOpen() {
    if (this.dataset.designMode === 'true') return true;

    const frequency = this.dataset.frequency || '24_hours';
    if (frequency === 'every_visit') return true;

    try {
      if (frequency === 'session') {
        return window.sessionStorage.getItem(this.#storageKey) !== 'dismissed';
      }

      const dismissedUntil = Number(window.localStorage.getItem(this.#storageKey) || 0);
      return dismissedUntil <= Date.now();
    } catch {
      return true;
    }
  }

  #rememberDismissal = () => {
    if (this.dataset.designMode === 'true') return;

    const frequency = this.dataset.frequency || '24_hours';
    if (frequency === 'every_visit') return;

    try {
      if (frequency === 'session') {
        window.sessionStorage.setItem(this.#storageKey, 'dismissed');
        return;
      }

      const hours = frequency === '7_days' ? 168 : 24;
      window.localStorage.setItem(this.#storageKey, String(Date.now() + hours * 60 * 60 * 1000));
    } catch {
      // Storage can be unavailable in strict privacy modes; closing still works normally.
    }
  };

  get #storageKey() {
    return `kbbc-promotion-popup:${this.dataset.campaignId || 'default'}`;
  }
}

if (!customElements.get('kbbc-promotion-popup')) {
  customElements.define('kbbc-promotion-popup', KbbcPromotionPopup);
}
